import { getDocs, orderBy, query, where } from "firebase/firestore";
import { RepositoryFirebase } from "../common/repository.firebase";
import { CashMovement } from "./cash-movement.entity";

class CashMovementRepository extends RepositoryFirebase<CashMovement> {
  static readonly instance = new CashMovementRepository();

  protected collection = "cash-movements";
  protected entity = CashMovement;

  async listBySession(sessionId: string): Promise<CashMovement[]> {
    const ref = this.getCollection();
    const q = query(ref, where("sessionId", "==", sessionId), orderBy("createdAt", "asc"));
    const snap = await getDocs(q);
    return Promise.all(
      snap.docs.map((d) => CashMovement.build(d.id, d.data() as Record<string, unknown>))
    );
  }
}

export const cashMovementRepository = CashMovementRepository.instance;
